import React from 'react';
export const Profile = React.lazy(() => import('./Profile'));
export const Settings = React.lazy(() => import('./Settings'));
